
const digest = '5d2bce4615a50fe1665d2168fb2793d425f9b400fe0d0f9e01d39a1cb7308c1d';
const classes = {"wrapper":"_wrapper_1vmc8_1","warning":"_warning_1vmc8_1","row":"_row_1vmc8_5","exemptioned":"_exemptioned_1vmc8_9","name":"_name_1vmc8_12","identificationNumber":"_identificationNumber_1vmc8_15","role":"_role_1vmc8_18","controls":"_controls_1vmc8_21","submit":"_submit_1vmc8_25"};
const css = `._wrapper_1vmc8_1 ._warning_1vmc8_1 {
  color: #f00;
  margin-bottom: 20px;
}
._wrapper_1vmc8_1 ._row_1vmc8_5 {
  display: flex;
  flex-direction: row;
}
._wrapper_1vmc8_1 ._row_1vmc8_5._exemptioned_1vmc8_9 {
  text-decoration: line-through;
}
._wrapper_1vmc8_1 ._row_1vmc8_5 ._name_1vmc8_12 {
  width: 20%;
}
._wrapper_1vmc8_1 ._row_1vmc8_5 ._identificationNumber_1vmc8_15 {
  width: 20%;
}
._wrapper_1vmc8_1 ._row_1vmc8_5 ._role_1vmc8_18 {
  width: 20%;
}
._wrapper_1vmc8_1 ._row_1vmc8_5 ._controls_1vmc8_21 {
  width: 40%;
  text-align: right;
}
._wrapper_1vmc8_1 ._submit_1vmc8_25 {
  margin-top: 20px;
  display: inline-block;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  